export const announcementsConstants = {
	GET_ANNOUNCEMENTS_REQUEST: 		"GET_ANNOUNCEMENTS_REQUEST",
	GET_ANNOUNCEMENTS_SUCCESS: 		"GET_ANNOUNCEMENTS_SUCCESS",
	GET_ANNOUNCEMENTS_FAILURE: 		"GET_ANNOUNCEMENTS_FAILURE",
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/announcementsConstants.js